module.exports = __webpack_public_path__ + "static/media/miu.d524d11a.png";